import { post } from '@/core/api/api.service';
import {
  PageSearchRequest,
  ProfileSearchRequest,
  SearchResponse,
} from '@/shared/searchProvider';
import { toCategorySlug, toProductSlug } from './filterSlugs';
import {
  IRingSearchEnvelope,
  IRingSearchItem,
  IRingSearchRequestBody,
  RingSearchEntityType,
  RingSearchFacet,
} from './types';

const PIPELINE = 'appGallery';
const SEARCH_PATH = '/services/ringsearch/v1/search.servlet';

const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const buildEndpoint = (): string => {
  const baseUrl = (RCAPW.ringSearchBaseUrl || '').replace(/\/$/, '');
  return `${baseUrl}${SEARCH_PATH}`;
};

const omitUndefined = <T extends object>(obj: T): T => {
  const result = {} as T;
  (Object.keys(obj) as Array<keyof T>).forEach((key) => {
    if (obj[key] !== undefined) {
      result[key] = obj[key];
    }
  });
  return result;
};

const unpack = (
  envelope: IRingSearchEnvelope,
): SearchResponse<IRingSearchItem> => ({
  items: envelope?.content?.items ?? [],
  totalCount: envelope?.content?.pagination?.totalItems ?? 0,
});

export const searchProfiles = ({
  brand,
  keyword,
  product,
  category,
  paging,
}: ProfileSearchRequest): Promise<SearchResponse<IRingSearchItem>> => {
  const productSlug = toProductSlug(product);
  const categorySlug = toCategorySlug(category);

  const body: IRingSearchRequestBody = omitUndefined({
    appId: RCAPW.ringSearchAppId,
    pipeline: PIPELINE,
    query: keyword,
    [RingSearchFacet.TYPE]: [RingSearchEntityType.PROFILE],
    [RingSearchFacet.BRAND]: [brand],
    [RingSearchFacet.PRODUCT]: productSlug ? [productSlug] : undefined,
    [RingSearchFacet.CATEGORY]: categorySlug ? [categorySlug] : undefined,
    pageNumber: paging.page,
    pageItems: paging.perPage,
    wrapperStart: '',
    wrapperEnd: '',
  });

  return post<IRingSearchEnvelope>(buildEndpoint(), body, { headers: HEADERS })
    .then(unpack)
    .catch((err) => {
      throw err;
    });
};

export const searchPages = ({
  brand,
  keyword,
  paging,
}: PageSearchRequest): Promise<SearchResponse<IRingSearchItem>> => {
  const body: IRingSearchRequestBody = {
    appId: RCAPW.ringSearchAppId,
    pipeline: PIPELINE,
    query: keyword,
    [RingSearchFacet.TYPE]: [RingSearchEntityType.PAGE],
    [RingSearchFacet.BRAND]: [brand],
    pageNumber: paging.page,
    pageItems: paging.perPage,
    wrapperStart: '',
    wrapperEnd: '',
  };

  return post<IRingSearchEnvelope>(buildEndpoint(), body, { headers: HEADERS })
    .then(unpack)
    .catch((err) => {
      throw err;
    });
};
